import React from 'react';
import { useSelector } from 'react-redux';
import { Template } from 'models/caller';
import { getCallerTemplateCloneLocation } from 'routing/paths/caller';
import { RootState } from 'reducers';
import { UpdateTemplate } from 'actions/caller';
import { useForm, useFormActionLoader, useFormEditToogleActions } from 'hooks/form';
// components
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import DeleteButton from 'components/Buttons/DeleteButton';
import CloneButton from 'components/Buttons/CloneButton';
import { CallerTemplateForm, TemplateFormField } from 'components/Caller';
import { Dialog } from 'components/Caller/TemplateDialogs/Dialog';

interface Props {
  template: Template;
  openDialog: (dialog: Dialog) => void;
}

export const CallerTemplateManagment = (props: Props): JSX.Element => {
  const { template, openDialog } = props;
  const isLocked = useSelector((state: RootState) => state.caller.template.isLocked(template.template_id));

  const form = useForm<Template, TemplateFormField>({
    initialState: props.template,
    showFields: [
      TemplateFormField.name,
      TemplateFormField.templateSute,
      TemplateFormField.messageType,
    ]
  });

  const { doAction } = useFormActionLoader();
  const { editMode, actions } = useFormEditToogleActions({
    canEdit: !isLocked,
    canSave: form.isChange,
    onSave: () => {
      if (!form.validate()) {
        return false;
      }

      doAction({
        action: UpdateTemplate(form.state),
        onError: form.catchError
      });
    },
    onCancel: form.reset
  });

  return (
    <Card>
      <CardHeader
        title="Template management"
        action={
          <>
            { actions }
            { editMode ? '' :
              <DeleteButton type="icon" isLoading={ isLocked } onClick={ () => openDialog(Dialog.DELETE) }/>
            }
            { editMode ? '' :
              <CloneButton type="icon" LinkTo={ getCallerTemplateCloneLocation(template) }/>
            }
          </>
        }
      />
      <CardContent>
        <CallerTemplateForm isView={ !editMode } { ...form } />
      </CardContent>
    </Card>
  );
};
